import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_2 = {
  key: 0,
  class: "spinner-message"
}
const _hoisted_3 = {
  key: 1,
  class: "spinner-dots"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!

  return (_ctx.getShowSpinner)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner, {
          name: "lines",
          duration: _ctx.spinnerDuration,
          paused: _ctx.spinnerPaused,
          enabled: _ctx.spinnerEnabled
        }, null, 8, ["duration", "paused", "enabled"]),
        (_ctx.spinnerMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.spinnerMessage), 1))
          : _createCommentVNode("", true),
        (_ctx.spinnerProgress !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledDots, (i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  class: "dot"
                }))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}